import { Form } from "antd";
import { useStore } from "zustand";
import { useDashboardName } from "../../store/headerName";
import { useEffect, useState } from "react";
import CustomBreadcrumb from "../../components/CustomBreadcrumb";
import FormCard from "../../components/card/FormCard";
import FormItemInput from "../../components/form-item/form-item-input";
import FormItemInputSelect from "../../components/form-item/form-item-input-select";
import ImageCard from "../../components/card/ImageCard";
import FormItemInputTextarea from "../../components/form-item/form-item-input-textarea";
import FormButton from "../../components/FormButton";
import { useNavigate, useSearchParams } from "react-router";
import { $api } from "../../helper";
import { statusShowMock, tokenMock } from "../../helper/mock";
import PreviewFile from "../../components/PreviewFile";
import { GetFullMediaPath } from "../../helper/method";
import { useNotify } from "../../helper/notify";

export default function AddFaqCategory() {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const notify = useNotify();
  const [fileList, setFileList] = useState<
    {
      file: File | undefined;
      fileUrl: string;
      id: string;
    }[]
  >([]);
  const [fileListMobile, setFileListMobile] = useState<
    {
      file: File | undefined;
      fileUrl: string;
      id: string;
    }[]
  >([]);

  const [searchParams] = useSearchParams();
  const { setDashboardName } = useStore(useDashboardName);
  const { data } = searchParams.get("u_id")
    ? $api.useQuery("get", "/site-api/v1/faq/category-detail/", {
        params: {
          query: {
            category_u_id: searchParams.get("u_id") || "",
          },
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: tokenMock,
          lang: "fa",
        },
      })
    : { data: undefined };

  const { mutate, isPending } = $api.useMutation(
    "post",
    "/site-api/v1/faq/category/",
  );

  const update = $api.useMutation("put", "/site-api/v1/faq/category/", {});

  useEffect(() => {
    setDashboardName("ایجاد دسته بندی جدید");
  }, []);

  useEffect(() => {
    if (searchParams.get("u_id") && data?.data) {
      setFileList([
        {
          file: undefined,
          fileUrl: GetFullMediaPath(data.data.desktop_image),
          id: data.data.title + data.data.u_id,
        },
      ]);
      setFileListMobile([
        {
          file: undefined,
          fileUrl: GetFullMediaPath(data.data.mobile_image),
          id: data.data.title + data.data.u_id,
        },
      ]);
      Object.entries(data?.data).forEach(([key, value]) => {
        form.setFieldValue(key, value?.toString());
      });
    }
  }, [data]);

  const onFinish = (
    values: {
      seo_description: string;
      seo_title: string;
      status: string;
      title: string;
    },
    redirect = true,
  ) => {
    const formData = new FormData();
    if (values.seo_description) {
      formData.append("seo_description", values.seo_description);
    }
    if (values.seo_title) {
      formData.append("seo_title", values.seo_title);
    }
    formData.append("status", values.status);
    formData.append("title", values.title);
    fileList.forEach((e) => {
      if (e.file || e.fileUrl) {
        formData.append("desktop_image", e.file ? e.file : e.fileUrl);
      }
    });
    fileListMobile.forEach((e) => {
      if (e.file || e.fileUrl) {
        formData.append("mobile_image", e.file ? e.file : e.fileUrl);
      }
    });
    if (searchParams.get("u_id")) {
      formData.append("category_u_id", searchParams.get("u_id") ?? "");
      update.mutate(
        {
          body: formData,
          headers: {
            Authorization: tokenMock,
            lang: "fa",
          },
        },
        {
          onSuccess: (data) => {
            notify.success(data.message);
            if (redirect) {
              navigate("/faq-category");
            } else {
              setTimeout(() => {
                window.location.href = window.location.pathname;
              }, 1000);
            }
          },
        },
      );
    } else {
      mutate(
        {
          body: formData,
          headers: {
            Authorization: tokenMock,
            lang: "fa",
          },
        },
        {
          onSuccess: (data) => {
            notify.success(data.message);
            form.resetFields();
            if (redirect) {
              navigate("/faq-category");
            } else {
              setTimeout(() => {
                window.location.href = window.location.pathname;
              }, 1000);
            }
          },
        },
      );
    }
  };

  return (
    <Form
      form={form}
      onFinish={(e) => onFinish(e)}
      layout="vertical"
      className="flex! flex-col! gap-6!"
    >
      <CustomBreadcrumb
        items={[
          {
            title: "دسته بندی سوالات متداول",
            href: "/faq-category",
          },
          {
            title: "ایجاد دسته بندی جدید",
          },
        ]}
      />
      <FormCard
        subTitle="تعریف و تنظیمات پایه مربوط به دسته‌بندی"
        title="اطلاعات اصلی دسته‌بندی"
      >
        <div className="grid sm:grid-cols-2 grid-cols-1 w-full gap-6">
          <FormItemInput
            name={"title"}
            rules={[
              {
                required: true,
                message: "عنوان اجباری است",
              },
            ]}
            className="col-span-1"
            label="نام دسته بندی"
            inputProps={{
              placeholder: "لطفا نام دسته بندی خود را وارد کنید.",
            }}
          />
          <FormItemInputSelect
            className="col-span-1"
            name={"status"}
            rules={[
              {
                required: true,
                message: "وضعیت اجباری است",
              },
            ]}
            label="وضعیت"
            inputProps={{
              placeholder: "لطفا وضعیت نمایش محصول خود را انتخاب کنید.",
              options: statusShowMock,
            }}
          />
        </div>
      </FormCard>
      <FormCard
        subTitle="تصاویر مربوط به نمایش دسته‌بندی در نسخه‌های مختلف"
        title="تصاویر دسته‌بندی"
      >
        <div className="grid sm:grid-cols-2 grid-cols-1 w-full gap-6">
          <div className="col-span-1 flex h-fit flex-col gap-2">
            <ImageCard
              id="desktop_image-1"
              name="desktop_image"
              setFile={setFileList}
              file={fileList}
            />
            {fileList?.map((e, i) => (
              <div className="w-40 h-40">
                <PreviewFile
                  id={e.id}
                  setFile={setFileList}
                  url={e.fileUrl}
                  key={"preview" + i}
                />
              </div>
            ))}
          </div>
          <div className="col-span-1 flex h-fit flex-col gap-2">
            <ImageCard
              id="mobile_image-1"
              name="mobile_image"
              setFile={setFileListMobile}
              file={fileListMobile}
            />
            {fileListMobile?.map((e, i) => (
              <div className="w-40 h-40">
                <PreviewFile
                  id={e.id}
                  setFile={setFileListMobile}
                  url={e.fileUrl}
                  key={"preview-mobile" + i}
                />
              </div>
            ))}
          </div>
        </div>
      </FormCard>
      <FormCard
        title="اطلاعات سئو"
        subTitle="بهینه‌سازی دسته‌بندی برای موتورهای جستجو"
      >
        <div className="grid sm:grid-cols-2 grid-cols-1 w-full gap-6">
          <FormItemInput
            label="عنوان سئو"
            rules={[
              {
                required: true,
                message: "عنوان سئو اجباری است",
              },
            ]}
            name={"seo_title"}
            className="col-span-1"
            inputProps={{
              placeholder: "لطفا عنوان سئو خود را وارد کنید.",
            }}
          />
          <FormItemInputTextarea
            label="توضیحات"
            rules={[
              {
                required: true,
                message: "توضیحات اجباری است",
              },
            ]}
            name={"seo_description"}
            className="col-span-1"
            inputProps={{
              className: "resize-none!",
              rows: 4,
              placeholder: "لطفا توضیحات اضافی سئو خود را بنویسید...",
            }}
          />
        </div>
      </FormCard>
      <FormButton
        isPending={isPending || update.isPending}
        ActionSaveAndStay={() => {
          form.validateFields().then(() => {
            onFinish(form.getFieldsValue(), false);
          });
        }}
      />
    </Form>
  );
}
